<template>
    <div class="input-group input-group-solid">
        <input id="city-search"
               :value="value"
               type="text"
               class="form-control"
               :placeholder="placeholder || __('actions.search')"
               @input="e => $emit('input', e.target.value)"
        >
        <div class="input-group-append">
            <button v-if="value && value !== ''" @click="$emit('input', '')" class="btn btn-light-danger" type="button">
                <i class="fas fa-times-circle p-0"/>
            </button>
            <span v-else class="input-group-text">
                <i class="text-muted" :class="[icon]"/>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        placeholder: String,
        icon: {
            type: String,
            default: 'fas fa-search',
        },
    },

    mounted() {
        if (this.value === undefined) {
            this.$emit('input', '');
        }
    },
};
</script>
